<form nz-form [formGroup]="form" class="w-full gap-2">

	<nz-form-item>
		<nz-form-label nzSpan="6" nzRequired>Trigger Type</nz-form-label>
		<nz-form-control nzSpan="16">
			<nz-select formControlName="triggerType">
				<nz-option *ngFor="let type of triggerTypes" 
						[nzValue]="type.value" 
						[nzLabel]="type.label"></nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>

	<nz-form-item>
		<nz-form-label  nzSpan="6" nzRequired>Trigger Name</nz-form-label>
		<nz-form-control [nzSpan]="16" [nzErrorTip]="'Name is required'">
			<input nz-input formControlName="triggerName" />
		</nz-form-control>
	</nz-form-item>

	<nz-form-item>
		<nz-form-label  nzSpan="6">Trigger Description</nz-form-label>
		<nz-form-control [nzSpan]="16" [nzErrorTip]="'Description is required'">
			<textarea nz-input formControlName="triggerDescription" rows="4" placeholder="Enter description"></textarea>
		</nz-form-control>
	</nz-form-item>

	<div *ngIf="isRecurring()" [formGroup]="recurringForm">
		<nz-form-item>
			<nz-form-label nzSpan="6">Frequency</nz-form-label>
			<nz-form-control nzSpan="16">
				<nz-select formControlName="frequency" nzPlaceHolder="Select frequency">
					<nz-option *ngFor="let frequency of frequencies" 
						[nzValue]="frequency.value" 
						[nzLabel]="frequency.label"></nz-option>
				</nz-select>
			</nz-form-control>
		</nz-form-item>
	</div>
	<div *ngIf="isPolicyRenewalReminder()">
		<nz-form-item>
			<nz-form-label nzSpan="6">Send</nz-form-label>
			<nz-form-control nzSpan="16">
			<div nz-row nzGutter="8">
				<div nz-col nzSpan="8">
				<input
					nz-input
					type="number"
					formControlName="reminderBeforeValue"
					min="1"
					placeholder="e.g. 3"
				/>
				</div>
				<div nz-col nzSpan="8">
				<nz-select
					formControlName="reminderBefore"
					nzPlaceHolder="Select period"
				>
					<nz-option
					*ngFor="let type of reminderBeforeTypes"
					[nzValue]="type.value"
					[nzLabel]="type.label"
					></nz-option>
				</nz-select>
				</div>
				<div nz-col nzSpan="8" class="mt-1">
				<span>before policy renewal</span>
				</div>
			</div>
			</nz-form-control>
		</nz-form-item>
	</div>

	<nz-form-item>
		<nz-form-label nzSpan="6">Start Date</nz-form-label>
		<nz-form-control nzSpan="16" [nzErrorTip]="startDateErrorTpl">
			<nz-date-picker formControlName="startDate"
				nzFormat="yyyy-MM-dd"
				[nzShowToday]="false"
				[nzDisabledDate]="disablePastDates"></nz-date-picker>
		</nz-form-control>
	</nz-form-item>
	<ng-template #startDateErrorTpl let-control>
		<ng-container *ngIf="control.hasError('invalidDate')">
			{{ control.getError('invalidDate') }}
		</ng-container>
	</ng-template>

	<nz-form-item>
		<nz-form-label nzSpan="6">Time</nz-form-label>
		<nz-form-control nzSpan="16">
			<nz-time-picker formControlName="time"
				nzFormat="HH:mm"></nz-time-picker>
		</nz-form-control>
	</nz-form-item>

	<div *ngIf="getScheduleDescription() !== undefined">
		<nz-divider nzText="Schedule" nzOrientation="center"></nz-divider>
		<div [innerHTML]="getScheduleDescription()"></div>
		<nz-divider nzOrientation="center"></nz-divider>
	</div>

	<nz-form-item>
		<nz-form-control nzSpan="24" class="mt-2 text-end">
			<div class="inline-flex gap-2">
				<button nz-button nzType="primary" class="me-2" (click)="onSubmit()">Save</button>
				<button nz-button nzType="default"  (click)="cancel()">Cancel</button>
			</div>
		</nz-form-control>
	</nz-form-item>
</form>